exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videos__container__1DBOF{margin-top:15px;height:100%}.videos__slider-container__3JEm3{overflow:visible}.videos__thumbnail-wrapper__2EUaA{position:relative;overflow:hidden}.videos__buttons__25xer{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;line-height:18px;height:18px;margin-top:14px;margin-bottom:5px}.videos__next-button__1QE64,.videos__prev-button__3Xlpb{background-color:rgba(0,0,0,.8)}.videos__next-button__1QE64>svg,.videos__prev-button__3Xlpb>svg{width:9px;height:18px}", ""]);

// exports
exports.locals = {
	"container": "videos__container__1DBOF",
	"slider-container": "videos__slider-container__3JEm3",
	"sliderContainer": "videos__slider-container__3JEm3",
	"thumbnail-wrapper": "videos__thumbnail-wrapper__2EUaA",
	"thumbnailWrapper": "videos__thumbnail-wrapper__2EUaA",
	"buttons": "videos__buttons__25xer",
	"next-button": "videos__next-button__1QE64",
	"nextButton": "videos__next-button__1QE64",
	"prev-button": "videos__prev-button__3Xlpb",
	"prevButton": "videos__prev-button__3Xlpb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/classic/components/videos/videos.styl
// module id = 2934
// module chunks = 1